import {
  takeLatest, call, cancel,
} from 'redux-saga/effects';
import { select } from 'app/store/utils/saga/effects';

import * as request from 'app/lib/provider/request';

import * as cardActions from '../actions';

export const config = {
  action: cardActions.sendOpened.type,
  method: takeLatest,
};

export function* func() {
  const { type } = yield* select((state) => state.card?.common?.identity);
  const uuid = yield* select((state) => state.card?.common?.uuid);

  if (!uuid) {
    yield cancel(); return;
  }

  try {
    yield call(() => request.opened(uuid, type));
  } catch (error) {
    console.error(error);
    yield cancel();
  }
}
